"use strict";
/*
 * Created on 12 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../../core/model/overview/AbstractEntityFilter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutIdentificationFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(SelloutIdentificationFilter, _AbstractEntityFilter);

  function SelloutIdentificationFilter(selloutTypes, categoryIds, priceZoneId, siteIds, productExternalIds, inRelease) {
    var _this;

    _classCallCheck(this, SelloutIdentificationFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutIdentificationFilter).call(this));
    _this.selloutTypes = selloutTypes;
    _this.categoryIds = categoryIds;
    _this.priceZoneId = priceZoneId;
    _this.siteIds = siteIds;
    _this.productExternalIds = productExternalIds;
    _this.inRelease = inRelease;
    return _this;
  }

  return SelloutIdentificationFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.SelloutIdentificationFilter = SelloutIdentificationFilter;